import type { ProspectHomepageSlide } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';
import type Slider from 'react-slick';

import CarouselSlider from '../../../CarouselSlider';
import type { SharedSliderProps } from '../SliderLayout';

import styles from './CardsSlider.scss';
import CardsSliderItem from './CardsSliderItem';

interface Props {
  asNavFor?: Slider;
  autoRotate: boolean;
  sharedSliderProps: SharedSliderProps;
  sliderRef: (slider: Slider) => void;
  slides: ProspectHomepageSlide[];
}

const CardsSlider: React.FC<Props> = ({
  asNavFor,
  autoRotate,
  sharedSliderProps,
  sliderRef,
  slides
}) => {
  if (slides.length === 1) {
    return (
      <div className={styles.cardsCarousel}>
        <CardsSliderItem
          key={slides[0].uid}
          clickHandler={sharedSliderProps.onSwipe}
          slide={slides[0]}
        />
      </div>
    );
  }

  return (
    <CarouselSlider
      {...sharedSliderProps}
      asNavFor={asNavFor}
      autoRotate={autoRotate}
      sliderRef={sliderRef}
      slidesToShow={1}
      wrapperClassName={classNames(styles.cardsCarousel, {
        [styles.twoSlides]: slides.length === 2
      })}
    >
      {slides.map((slide) => (
        <CardsSliderItem key={slide.uid} clickHandler={sharedSliderProps.onSwipe} slide={slide} />
      ))}
    </CarouselSlider>
  );
};

export default CardsSlider;
